<script>
  import Button from "../UI/Button.svelte";
  import { createEventDispatcher } from "svelte";
  import { tweened } from "svelte/motion";
  import CalendarPlot from "./CalendarPlot.svelte";
  import { slide } from "svelte/transition";

  export let data;
  export let plant;

  const dispatch = createEventDispatcher();
  
</script>

<article transition:slide={{ duration: 250 }}>

  <div class="plant-image">
    <div style="position:relative;">

      <div class="plant-image"  style="position:absolute; top:0; left:0;">
        <object  data="../../static/plant-icons/background.svg" type="image/svg+xml"  title="background"></object>
      </div>

      <div class="plant-image" style="position:absolute; top:49px; left:0;">
        <object data="../../static/plant-icons/{ plant.commonName }.svg" type="image/svg+xml"  title={plant.commonName}></object>
      </div>
    </div>
  </div>

  <div class="plant-details">
    <div class="info">
      <div class="plant-title">
          <div>
          <h1>
            {plant.commonName}
          </h1></div>
          <div>
          <h2>
            <a href={plant.URL} target="_blank">{plant.scientificName}</a>
          </h2>
        </div>
      </div>

      <!-- <div class="seed-cta">
        <Button
          mode="success"
          on:click={() => dispatch("toggleseeds", plant.plantId)}
          >Find Seeds</Button
        >
      </div> -->
    </div>
    <div class="planting-calendar">
      <div class="plot"><CalendarPlot {data} 
        on:toggleseeds 
        />
      </div>
    </div>
  </div>
</article>

<style>
  article {
    border-radius: var(--space-8x);
    border-color: black;
    border-style: solid;
    display: flex;
    padding: var(--space-2x);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    margin-top:15px;
  }

  .info {
    display: flex;
    justify-content: space-between;
    width: 1020px;
  }

  .plant-details {
    padding-left: var(--space-2x);
  }

  .plant-title {
    display: flex;
    justify-content: space-between;
    padding:  var(--space-2x);
    gap: var(--space-2x);;
    align-items:baseline;
  } 

  .plantIconContainer {
    position:relative;
    width:100px;
  }

  .plantIcon {
      position:absolute;
  }
  .plantIconBG {
      position:absolute;
      /* transform: translate(0px, 100px); */
  }


  h1,h2{
    display: inline;
  }


  h1 {
    font-style: bold;
    font-weight: 700;
    font-size: var(--text-07);
    font-family: tuppence,serif;
    font-variant-ligatures: discretionary-ligatures;

  }

  h2 {
    font-style: italic;
    color: grey;
    font-weight: 200;
    font-size: var(--text-07);
    font-family: tuppence,serif;
    font-variant-ligatures: discretionary-ligatures;
  }
</style>
